import React from 'react';

export const ExitAppIcon = ({
  color = 'black',
  size = '20',
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
    >
      <path
        data-name="Tracé 1601"
        d="M12.075 4.179h-5.9v8.254h5.9v-.59a.59.59 0 1 1 1.179 0v.707a1.061 1.061 0 0 1-1.061 1.061H6.061A1.061 1.061 0 0 1 5 12.551v-8.49A1.061 1.061 0 0 1 6.061 3h6.131a1.061 1.061 0 0 1 1.061 1.061v.707a.59.59 0 0 1-1.179 0zm-.328 4.729L7.946 8.9a.59.59 0 0 1 0-1.179l3.81.013v-.018l-.741-.741a.619.619 0 0 1 .875-.875l1.769 1.769a.619.619 0 0 1 0 .875l-1.769 1.769a.619.619 0 1 1-.875-.875z"
        transform="translate(1 2)"
        style={{ fill: color }}
      />
      <path style={{ fill: 'none' }} d="M0 0h20v20H0z" />
    </svg>
  );
};
